// extracted by mini-css-extract-plugin
module.exports = {"xpaContainer":"News_xpaContainer__xGSVP","matchCardComponentWrapper":"News_matchCardComponentWrapper__RAqV0"};